import moment from "moment";
import { MonetaryAmount } from "../../../app/domain/monetary-amount";
import { translate as t } from "../../translate/localization";

const getHeadersConfig = (isMexicanCompany = false) => ({
  massiveEdit: [
    t("spreadsheet-headers.name"),
    t("spreadsheet-headers.surnames"),
    t("spreadsheet-headers.email"),
    t("spreadsheet-headers.nif"),
    t("spreadsheet-headers.birth-date"),
    t("spreadsheet-headers.annual-gross-salary"),
    t("spreadsheet-headers.workTimePercentage"),
    t("spreadsheet-headers.collective-agreement-salary"),
    t("spreadsheet-headers.number-of-paychecks"),
    t("spreadsheet-headers.internal-id"),
    t("spreadsheet-headers.cost-center"),
    t("spreadsheet-headers.subsidiary"),
    t("spreadsheet-headers.hiring-date"),
    t("spreadsheet-headers.nationality"),
    t("spreadsheet-headers.sex"),
    t("spreadsheet-headers.address-street-name"),
    t("spreadsheet-headers.address-street-number"),
    t("spreadsheet-headers.address-block"),
    t("spreadsheet-headers.address-floor"),
    t("spreadsheet-headers.address-door"),
    t("spreadsheet-headers.address-details"),
    t("spreadsheet-headers.address-postal-code"),
    t("spreadsheet-headers.address-locality"),
    t("spreadsheet-headers.address-province"),
    ...(isMexicanCompany ? [t("spreadsheet-headers.address-district")] : []),
    t("spreadsheet-headers.mobile-country-code"),
    t("spreadsheet-headers.mobile-phone-number"),
    t("spreadsheet-headers.bank-account"),
  ],
  movements: [
    t("common-messages.date"),
    t("common-messages.society"),
    t("common-messages.cost-center"),
    t("common-messages.concept"),
    t("my-account-section.payroll"),
    t("my-account-section.operation-timestamp"),
    t("my-account-section.statement-timestamp"),
    t("common-messages.amount"),
    t("my-account-section.initial-balance"),
    t("my-account-section.finish-balance"),
    t("my-account-section.currency"),
  ],
});

const dataConfig = (data, isMexicanCompany = false) => {
  const {
    name = "",
    surname = "",
    email = "",
    legalId = "",
    internalId = "",
    costCenter = "",
    payrollCompany = "",
    hiringDate = "",
    timestamp,
    concept = "",
    payrollMonth = "",
    statementTimestamp,
    operationTimestamp,
    amount = MonetaryAmount.ZERO,
    initial = MonetaryAmount.ZERO,
    final = MonetaryAmount.ZERO,
    workTimePercentage = 100,
    birthDate,
    collectiveAgreementSalary,
    numberOfPaychecks,
    nationality,
    sex,
    homeAddress,
    mobileCountryCode,
    mobilePhone,
    bankAccount,
  } = data;

  const payroll =
    payrollMonth && payrollMonth === "unreported"
      ? `${t("my-account-section.unreported")}`
      : `${moment(payrollMonth).format("MMMM")}`;

  return {
    massiveEdit: [
      name,
      surname,
      email,
      legalId,
      birthDate ? moment(birthDate).format("DD/MM/YYYY") : "",
      t("upload-employees-section.hidden"),
      workTimePercentage.toFixed(2),
      collectiveAgreementSalary &&
        MonetaryAmount.ofCurrency(collectiveAgreementSalary).toUnitary(),
      numberOfPaychecks,
      internalId,
      costCenter,
      payrollCompany,
      hiringDate ? moment(hiringDate).format("DD/MM/YYYY") : "",
      nationality,
      sex,
      homeAddress.streetName,
      homeAddress.streetNumber,
      homeAddress.block,
      homeAddress.floor,
      homeAddress.door,
      homeAddress.details,
      homeAddress.postalCode,
      homeAddress.locality,
      homeAddress.province,
      ...(isMexicanCompany ? [homeAddress.district] : []),
      mobileCountryCode,
      mobilePhone,
      bankAccount,
    ],
    movements: [
      timestamp ? moment(timestamp).format("DD/MM/YYYY HH:mm") : "",
      payrollCompany,
      costCenter,
      concept,
      payrollMonth ? payroll : "-",
      operationTimestamp ? moment(operationTimestamp).format("DD/MM/YY") : "",
      statementTimestamp ? moment(statementTimestamp).format("DD/MM/YY") : "",
      new MonetaryAmount(amount.amountInCents, amount.currency).toUnitary(),
      new MonetaryAmount(initial.amountInCents, amount.currency).toUnitary(),
      new MonetaryAmount(final.amountInCents, amount.currency).toUnitary(),
      amount.currency,
    ],
  };
};

export const adaptDataToCsv = ({ type, data, isMexicanCompany = false }) => {
  const rows = data.map((item) => dataConfig(item, isMexicanCompany)[type]);
  return {
    headers: getHeadersConfig(isMexicanCompany)[type],
    rows,
  };
};
